import React from 'react';
import PropTypes from 'prop-types';
import navbarStore from 'components/navbar/NavbarStore';
import Navbar from 'components/navbar/Navbar';
import {FooterSection} from 'components/LandingPage';
import FerryPartner from 'ferries/helpers/FerryPartner';
import {isFerryPartner, isNative} from 'ferries/helpers/common';
import {ferryPartnerTranslations} from 'ferries/helpers/translations';

const Layout = ({id, children}) => (
  <div id={id}>
    {!isNative() && <Navbar navbar={navbarStore} />}
    {children}
    {isFerryPartner && <FerryPartner translations={ferryPartnerTranslations} />}
    {!isNative() && <FooterSection />}
  </div>
);

Layout.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default Layout;
